// src/utils/richText.js
import DOMPurify from 'isomorphic-dompurify';

/**
 * Convierte un texto con Markdown LIGERO a HTML seguro.
 * Soporta lo mínimo que la clienta pidió, sin dependencias pesadas:
 *   **negrita**        -> <strong>
 *   *cursiva*          -> <em>
 *   [texto](url)       -> <a href> (http/https/mailto)
 *   saltos de línea    -> <br>
 *
 * SIEMPRE pasa por DOMPurify al final: aunque el input parezca inofensivo,
 * se sanea para bloquear cualquier HTML/JS malicioso pegado por el admin.
 */
export function markdownLigeroAHtml(texto) {
  if (!texto || typeof texto !== 'string') return '';

  // 1) Escapar HTML crudo para que el usuario no inyecte tags directamente.
  let html = texto
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  // 2) Enlaces [texto](url) — solo http/https/mailto.
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)/g,
    (m, txt, url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${txt}</a>`
  );

  // 3) Negrita y cursiva.
  html = html
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>');

  // 4) Saltos de línea -> <br>.
  html = html.replace(/\n/g, '<br>');

  // 5) Sanitización final (defensa en profundidad).
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['strong', 'em', 'a', 'br'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOWED_URI_REGEXP: /^(https?:|mailto:)/i,
  });
}